import { render, staticRenderFns } from "./Misnomer.vue?vue&type=template&id=7b7609b1"
import script from "./Misnomer.vue?vue&type=script&lang=js"
export * from "./Misnomer.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports